import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { StringHelper } from 'src/app/helper/string/string-helper';
import { ToastService } from 'src/app/share/toast/toast.service';

@Injectable({
	providedIn: 'root',
})
export class AlertService {

	constructor(private alertController: AlertController, private toastService: ToastService) {}

	public async show(message: string, header = 'Message'): Promise<void> {
		return new Promise(async (resolve) => {
			const alert = await this.alertController.create({
				cssClass: 'app-alert',
				header,
				message,
				buttons: [
					{
						text: 'OK',
						cssClass: 'dialog-default',
						handler: () => {
							return resolve();
						},
					},
				],
			});
			await alert.present();
		});
	}

	public async error(data?: any): Promise<any> {
		if (data?.error?.code === 'unstarted_shift') {
			return null;
		}
		return new Promise(async (resolve) => {
			const alert = await this.alertController.create({
				cssClass: 'app-alert',
				header: 'Message',
				message: StringHelper.error(data),
				buttons: [
					{
						text: 'OK',
						cssClass: 'dialog-default',
					},
				],
			});
			await alert.present();
		});
	}

	public async confirm(
		detail: string = "",
		yesLabel: string = 'Yes',
		noLabel: string = 'No',
		header: string = "",
		timeout = null
	): Promise<any> {
		return new Promise(async (resolve) => {
			const alert = await this.alertController.create({
				cssClass: 'app-alert',
				header,
				message: detail,
				buttons: [
					{
						text: noLabel,
						cssClass: 'dialog-default',
						handler: () => {
							resolve(false);
						},
					},
					{
						text: yesLabel,
						cssClass: 'dialog-default',
						handler: () => {
							resolve(true);
						},
					},
				],
			});
			if (timeout) {
				setTimeout(() => alert.dismiss(), timeout);
			}
			await alert.present();
		});
	}

	public async forceConfirm(
		detail: string = "",
		yesLabel: string = 'Yes',
		noLabel: string = 'No',
		header: string = "",
		timeout = null
	): Promise<any> {
		return new Promise(async (resolve) => {
			const alert = await this.alertController.create({
				cssClass: 'app-alert',
				header,
				message: detail,
				buttons: [
					{
						text: noLabel,
						cssClass: 'dialog-no',
						handler: () => {
							resolve(false);
						},
					},
					{
						text: yesLabel,
						cssClass: 'dialog-yes',
						handler: () => {
							resolve(true);
						},
					},
				],
			});
			if (timeout) {
				setTimeout(() => alert.dismiss(), timeout);
			}
			await alert.present();
		});
	}

	public toast(message: string,  options?: {
		buttonLabel?: string,
		duration?: number;
		autoDismiss?: boolean,
		data?: any
	}): Promise<any> {
		return this.toastService.toast(message, options);
	}
}
